export default {
    data() {
        return {
            urlRouteName: [
                { index: 0, areaName: "centre-on-y-va" },
                { index: 1, areaName: "service-educatif" },
                { index: 2, areaName: "service-parascolaire" },
                { index: 3, areaName: "milieu-familial" }
            ],
            urlSituationsName: [
                { index: 0, situationName: "l-accueil-des-familles" },
                { index: 1, situationName: "l-ecoute-visible" },
                { index: 2, situationName: "un-milieu-inclusif-et-stimulant-pour-toutes-et-tous" },
                { index: 3, situationName: "ici-je-suis-chez-moi" },
                { index: 4, situationName: "nature-et-decouverte" },
                { index: 5, situationName: "un-environnement-riche-en-experiences-d-apprentissage" },
                { index: 6, situationName: "cultiver-de-saines-habitudes-de-vie" },
                { index: 7, situationName: "on-joue-dehors" },
                { index: 8, situationName: "l-expression-sous-toutes-ses-formes" },
                { index: 9, situationName: "a-la-decouverte-de-ma-communaute" },
                { index: 10, situationName: "prete-ou-pret-pour-l-ecole-prete-ou-pret-pour-la-vie" },
                { index: 11, situationName: "explorons-le-jeu-aventureux" }
            ],
            areaSituationsMatch: [
                { index: 0, situations: [0, 5, 10] },
                { index: 1, situations: [1, 6, 7] },
                { index: 2, situations: [2, 4, 9] },
                { index: 3, situations: [3, 8, 11] }
            ],
        }
    }
}
